import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import API from "../services/api-request";

const mergeUniqueById = (prevData, newData) => {
  const existingIds = new Set(prevData.map((item) => item.id));
  return [
    ...prevData,
    ...newData.filter((item) => !existingIds.has(item.id)),
  ];
};

const SelectProduct = ({ value, onChange, nullOptions, idClient }) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getProduct = useCallback(async () => {
    setLoading(true);
    API.Get(`product${idClient ? "?client_id=" + idClient : ""}`)
      .then((res) => {
        const newData = res?.data;
        setListData((prevData) => mergeUniqueById(prevData, newData));
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [idClient]);

  useEffect(() => {
    getProduct();
  }, [getProduct, idClient]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder={nullOptions ? "Pilih Client Dahulu" : "Pilih Produk"}
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={
        nullOptions
          ? null
          : listData?.map((e) => ({
              label: e.name,
              value: e.id,
            }))
      }
    />
  );
};


SelectProduct.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  nullOptions: PropTypes.array,
  idClient: PropTypes.any,
};

export default SelectProduct;
